import { useState } from "react";
import { useAuth } from "./AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const [loginId,  setLoginId]  = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async () => {
    if (!loginId.trim() || !password.trim()) { setError("Please enter both login ID and password."); return; }
    setLoading(true); setError("");
    try {
      const result = await login(loginId.trim(), password);
      if (!result.success) setError(result.error);
    } catch {
      setError("Connection error. Please check your internet and try again.");
    }
    setLoading(false);
  };

  const handleKey = (e) => { if (e.key === "Enter") handleLogin(); };

  return (
    <div className="login-shell" style={{ fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>

      {/* Left branding panel */}
      <div className="login-left">
        <div>
          <div style={{ fontSize: 24, fontWeight: 700, color: "#FFF", letterSpacing: "-0.03em" }}>MealBox</div>
          <div style={{ fontSize: 13, color: "#78716C", marginTop: 4 }}>Business Console</div>
        </div>
        <div className="login-features">
          <div style={{ fontSize: 24, fontWeight: 600, color: "#FFF", lineHeight: 1.3, letterSpacing: "-0.02em", marginBottom: 16 }}>
            Manage your meal<br />subscription business
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {[
              { icon: "◎", text: "Subscriber & meal tracking" },
              { icon: "◉", text: "Daily delivery management" },
              { icon: "◆", text: "Pause & resume per customer" },
              { icon: "▦", text: "Revenue & renewal dashboard" },
            ].map(f => (
              <div key={f.text} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ color: "#78716C", fontSize: 14 }}>{f.icon}</span>
                <span style={{ color: "#A8A29E", fontSize: 13 }}>{f.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ fontSize: 11, color: "#44403C" }}>© 2026 MealBox</div>
      </div>

      {/* Right login form */}
      <div className="login-right">
        <div style={{ width: "100%", maxWidth: 380 }}>
          <h2 style={{ fontSize: 22, fontWeight: 600, color: "#1C1917", margin: "0 0 6px", letterSpacing: "-0.02em" }}>Sign in</h2>
          <p style={{ fontSize: 13, color: "#78716C", margin: "0 0 2rem" }}>Enter your service provider credentials</p>

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div>
              <label style={{ display: "block", fontSize: 12, color: "#78716C", marginBottom: 6, fontWeight: 500 }}>Login ID</label>
              <input value={loginId} onChange={e => { setLoginId(e.target.value); setError(""); }}
                onKeyDown={handleKey} placeholder="e.g. spice_kitchen"
                style={{ width: "100%", padding: "10px 14px", fontSize: 14, borderRadius: 10, border: `1px solid ${error ? "#F09595" : "#E7E5E0"}`, outline: "none", boxSizing: "border-box", background: "#FFF" }} />
            </div>

            <div>
              <label style={{ display: "block", fontSize: 12, color: "#78716C", marginBottom: 6, fontWeight: 500 }}>Password</label>
              <div style={{ position: "relative" }}>
                <input type={showPass ? "text" : "password"}
                  value={password} onChange={e => { setPassword(e.target.value); setError(""); }}
                  onKeyDown={handleKey} placeholder="Enter password"
                  style={{ width: "100%", padding: "10px 40px 10px 14px", fontSize: 14, borderRadius: 10, border: `1px solid ${error ? "#F09595" : "#E7E5E0"}`, outline: "none", boxSizing: "border-box", background: "#FFF" }} />
                <button onClick={() => setShowPass(p => !p)}
                  style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 12, color: "#A8A29E" }}>
                  {showPass ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {error && (
              <div style={{ background: "#FCEBEB", border: "0.5px solid #F09595", borderRadius: 8, padding: "9px 12px", fontSize: 13, color: "#A32D2D" }}>
                {error}
              </div>
            )}

            <button onClick={handleLogin} disabled={loading}
              style={{ padding: "11px", fontSize: 14, fontWeight: 600, borderRadius: 10, border: "none", background: loading ? "#78716C" : "#1C1917", color: "#FFF", cursor: loading ? "default" : "pointer", marginTop: 4 }}>
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </div>

          {/* Demo account */}
          <div style={{ marginTop: "2rem", background: "#FFF", border: "0.5px solid #E7E5E0", borderRadius: 12, padding: "1rem 1.25rem" }}>
            <div style={{ fontSize: 12, fontWeight: 500, color: "#78716C", marginBottom: 8 }}>Demo account</div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div>
                <div style={{ fontSize: 13, color: "#1C1917", fontWeight: 500 }}>Spice Kitchen</div>
                <div style={{ fontSize: 11, color: "#A8A29E" }}>spice_kitchen / spice123</div>
              </div>
              <button onClick={() => { setLoginId("spice_kitchen"); setPassword("spice123"); setError(""); }}
                style={{ fontSize: 11, padding: "4px 12px", borderRadius: 6, border: "0.5px solid #E7E5E0", background: "#F7F6F2", cursor: "pointer", color: "#44403C" }}>
                Use
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
